import { render, staticRenderFns } from "./AuthForgotPassword.vue?vue&type=template&id=f0579dee&scoped=true"
import script from "./AuthForgotPassword.vue?vue&type=script&lang=js"
export * from "./AuthForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./AuthForgotPassword.vue?vue&type=style&index=0&id=f0579dee&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0579dee",
  null
  
)

export default component.exports